import { createFileRoute } from '@tanstack/react-router';
import { StandalonePlayPage } from '@/pages/standalone-play.page';

export const Route = createFileRoute('/standalone/play')({
  component: StandalonePlayPage,
});
